import { render, staticRenderFns } from "./img-previewer.vue?vue&type=template&id=321197df&scoped=true&"
import script from "./img-previewer.vue?vue&type=script&lang=js&"
export * from "./img-previewer.vue?vue&type=script&lang=js&"
import style0 from "./img-previewer.vue?vue&type=style&index=0&id=321197df&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../kuaishou-frontend-collect/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321197df",
  null
  
)

export default component.exports